import React from 'react';
import './MaintenancePage.css';

function formatEta(etaIso) {
  if (!etaIso) return null;
  try {
    const d = new Date(etaIso);
    if (isNaN(d.getTime())) return null;
    return d.toLocaleString('sv-SE', {
      hour: '2-digit',
      minute: '2-digit',
      day: '2-digit',
      month: '2-digit',
    });
  } catch {
    return null;
  }
}

export default function MaintenancePage({ message, etaIso }) {
  const etaLabel = formatEta(etaIso);
  return (
    <div className="maintenance-page" role="status" aria-live="polite">
      <div className="maintenance-page__inner">
        <div className="maintenance-page__brand">
          <svg xmlns="http://www.w3.org/2000/svg" viewBox="0 0 32 32" width="32" height="32" aria-hidden="true">
            <defs>
              <linearGradient id="kp-maint-grad" x1="0" y1="0" x2="1" y2="1">
                <stop offset="0%" stopColor="#3B82F6" />
                <stop offset="100%" stopColor="#2563EB" />
              </linearGradient>
            </defs>
            <rect width="32" height="32" rx="7" fill="url(#kp-maint-grad)" />
            <path d="M7 14h8v11H7V14zm12-7h8v18H19V7z" fill="#fff" />
          </svg>
          <span className="maintenance-page__brand-name">KanPlan</span>
        </div>

        <div className="maintenance-page__card">
          <div className="maintenance-page__pill">
            <span className="maintenance-page__pill-dot" />
            Underhåll pågår
          </div>

          <div className="maintenance-page__spinner-wrap">
            <div className="maintenance-page__spinner-bg" />
            <svg className="maintenance-page__spinner" viewBox="0 0 120 120" aria-hidden="true">
              <circle className="maintenance-page__spinner-track" cx="60" cy="60" r="51" />
              <circle className="maintenance-page__spinner-progress" cx="60" cy="60" r="51" />
            </svg>
            <svg
              className="maintenance-page__spinner-icon"
              viewBox="0 0 24 24"
              fill="none"
              stroke="currentColor"
              strokeWidth="2"
              strokeLinecap="round"
              strokeLinejoin="round"
              aria-hidden="true"
            >
              <path d="M14.7 6.3a1 1 0 0 0 0 1.4l1.6 1.6a1 1 0 0 0 1.4 0l3.77-3.77a6 6 0 0 1-7.94 7.94l-6.91 6.91a2.12 2.12 0 0 1-3-3l6.91-6.91a6 6 0 0 1 7.94-7.94l-3.76 3.76z" />
            </svg>
          </div>

          <h1 className="maintenance-page__title">Vi uppdaterar KanPlan</h1>
          <p className="maintenance-page__subtitle">
            {message
              || 'Plattformen är tillfälligt nere medan vi rullar ut en uppdatering. Inget arbete går förlorat — sidan kommer tillbaka automatiskt så snart vi är klara.'}
          </p>

          {etaLabel && (
            <div className="maintenance-page__eta">
              <span className="maintenance-page__eta-label">Beräknad återställning</span>
              <span className="maintenance-page__eta-value">{etaLabel}</span>
            </div>
          )}

          <div className="maintenance-page__footer">
            <a href="mailto:support@kanplan.se">Kontakta support</a>
          </div>
        </div>
      </div>
    </div>
  );
}
